import { PAYMENT_ACCESS, PAYMENT_ACTIVITY_VIEW_ACCESS } from './../../../security.attributes';
import { resetBillingLedger } from '../../../reducers/actions/customer.billing.actions';
import { BILLING_INVOICE_LIST_URL } from '../billing.payments.constants';
export function routing($stateProvider) {
  $stateProvider.state(BILLING_INVOICE_LIST_URL, {
    url: '/list',
    template: '<billing-payments-list></billing-payments-list>',
    resolve: {
      resetSearchBar: function resetSearchBar($ngRedux) {
        $ngRedux.dispatch(resetBillingLedger());
        return Promise.resolve();
      }
    },
    securityAttributes: [PAYMENT_ACCESS, PAYMENT_ACTIVITY_VIEW_ACCESS]
  });
}